import { Table as e } from "./components/Table.es.js";
import { TableRow as t } from "./components/TableRow.es.js";
import { TableCell as n } from "./components/TableCell.es.js";
import "./components/index.es.js";
import { consumes as r } from "./lib/consumes.es.js";
import { consume as i } from "./lib/consume.es.js";
// lib/Table/index.tsx
var a = () => ({
	class: "block",
	name: "core/table",
	consumer: {
		consumes: r,
		consume: i
	},
	actions: [],
	componentEntry: {
		class: "block",
		component: e,
		children: [{
			type: "row",
			class: "block",
			component: t,
			asOwnElement: !0,
			children: [{
				type: "cell",
				class: "text",
				constraints: { allowBreak: !1 },
				component: n,
				asOwnElement: !0
			}]
		}]
	}
});
export { a as Table };
